import React, { useState } from "react";
import ROLE from "../common/role";
import { IoMdClose } from "react-icons/io";
import summaryApi from "../common/index";
import { toast } from "react-toastify";

const ChangeUserRole = ({
  name,
  email,
  role,
  userId,
  imageUrl,
  onClose,
  callFunc,
}) => {
  const [userRole, setUserRole] = useState(role);

  const handleOnChangeSelect = (e) => {
    setUserRole(e.target.value);
  };

  const updateUserRole = async () => {
    try {
      const fetchResponse = await fetch(summaryApi.updateUser.url, {
        method: summaryApi.updateUser.method,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userId,
          role: userRole,
        }),
      });

      const responseData = await fetchResponse.json();

      if (responseData.success) {
        toast.success(responseData.message, {
          style: {
            background: "linear-gradient(to right, #06b6d4, #3b82f6)", // cyan to blue
            color: "white",
          },
          autoClose: 2000,
          closeOnClick: true,
        });
        onClose();
        callFunc();
      } else {
        toast.error(responseData.message, {
          style: {
            background: "linear-gradient(to right, #ef4444, #f87171)", // red shades
            color: "white",
          },
          autoClose: 3000,
          closeOnClick: true,
        });
      }
    } catch (error) {
      toast.error("An error occurred while updating the role", {
        style: {
          background: "linear-gradient(to right, #ef4444, #f87171)",
          color: "white",
        },
        autoClose: 3000,
        closeOnClick: true,
      });
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gradient-to-br from-white via-gray-50 to-white rounded-xl shadow-xl p-6 w-full max-w-md relative border border-gray-200">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition"
          onClick={onClose}
        >
          <IoMdClose size={24} />
        </button>
        <h1 className="text-2xl font-bold mb-6 text-gray-800">
          Change User Role
        </h1>

        <div className="flex items-center mb-6">
          <div className="bg-gray-100 p-1 rounded-full w-20 h-20 flex items-center justify-center overflow-hidden shadow-inner">
            <img
              src={
                imageUrl
                  ? imageUrl.startsWith("http")
                    ? imageUrl // Use Cloudinary or full URL
                    : `https://dates-website-backend.vercel.app/${imageUrl}` // fallback for local uploads
                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      name
                    )}&background=4f46e5&color=fff&size=128`
              }
              alt={name}
              className="w-full h-full object-cover rounded-full border-2 border-indigo-300"
            />
          </div>
          <div className="ml-4">
            <p className="text-gray-700 mb-2">
              <strong>Name:</strong> {name}
            </p>
            <p className="text-gray-700">
              <strong>Email:</strong> {email}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between mb-6">
          <p className="text-gray-700 font-medium">
            <strong>Role:</strong>
          </p>
          <select
            className="border border-gray-300 rounded-md px-4 py-2 text-gray-700 focus:ring-2 focus:ring-indigo-400 focus:outline-none transition"
            value={userRole}
            onChange={handleOnChangeSelect}
          >
            {Object.values(ROLE).map((el) => (
              <option value={el} key={el}>
                {el}
              </option>
            ))}
          </select>
        </div>

        <button
          className="w-full py-2 px-4 rounded-md bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold hover:from-indigo-600 hover:to-purple-600 transition shadow-lg"
          onClick={updateUserRole}
        >
          Change Role
        </button>
      </div>
    </div>
  );
};

export default ChangeUserRole;
